import React, { useContext } from 'react';
import '../../../styles/Home.scss'
import BannerSection from './bannerSection';
import FavoritesSection from './favoritesSection';
import FollowedMerchantsSection from './followedSection';
import MerchantSection from './merchantSection';
import { SessionContext } from '../../../Context/SessionContext';
import SEO from '../../../Components/seo';
import SaleSection from './saleSection';
import Menu from './Menu';
import YouMightLoveSection from './ymlSection';
import GottPlusSection from './gottPlus';
import VlogSection from './vlog';

const Home: React.FC = () => {
  const { session } = useContext(SessionContext);
  const { isAuthenticated } = session;

  return (
    <div className="home">
       <SEO />
       <Menu/>
      <BannerSection />
      {isAuthenticated && <FavoritesSection />}
      <SaleSection />
      <VlogSection />
      {/* Top Picks of the Week! */}
      <GottPlusSection />
      {isAuthenticated && <FollowedMerchantsSection />}
      <MerchantSection />
      <YouMightLoveSection />
      
    </div>
  );
};

export default Home;
